<template>
  <div class="item-description-area">
    <template v-for="(item, index) in descriptionItems">
      <HeadingThree
        v-if="item.type === 'heading'"
        :key="`heading-${index}`"
        :class="getMarginClass(index)"
      >
        {{ item.text }}
      </HeadingThree>
      <HeadingFour
        v-else-if="item.type === 'subheading'"
        :key="`subheading-${index}`"
        :class="getMarginClass(index)"
      >
        {{ item.text }}
      </HeadingFour>
      <ItemDescriptionText
        v-else-if="item.type === 'text'"
        :key="`text-${index}`"
        :class="getTextMarginClass(index)"
        :text="item.text"
      />
      <ItemDescriptionBoldText
        v-else-if="item.type === 'bold'"
        :key="`bold-${index}`"
        :class="getTextMarginClass(index)"
        :text="item.text"
      />
      <ItemDescriptionImage
        v-else-if="item.type === 'image'"
        :key="`image-${index}`"
        :class="getMarginClass(index)"
        :image-url="item.imageUrl"
        :caption="item.caption"
      />
      <ItemDescriptionLink
        v-else-if="item.type === 'link'"
        :key="`link-${index}`"
        :class="getMarginClass(index)"
        :url="item.url"
        :description="item.description"
        :heading="item.heading"
        :display-text="item.displayText"
      />
    </template>
    <ItemDescriptionMailSlotDeliverable
      v-if="mailSlotDeliverable"
      class="item-description-mail-slot-deliverable"
    />
  </div>
</template>

<script>
import HeadingThree from '../../atoms/headlines/HeadingThree.vue'
import HeadingFour from '../../atoms/headlines/HeadingFour.vue'
import ItemDescriptionText from '../../atoms/item_descriptions/ItemDescriptionText.vue'
import ItemDescriptionBoldText from '../../atoms/item_descriptions/ItemDescriptionBoldText.vue'
import ItemDescriptionImage from '../../atoms/item_descriptions/ItemDescriptionImage.vue'
import ItemDescriptionLink from '../../atoms/item_descriptions/ItemDescriptionLink.vue'
import ItemDescriptionMailSlotDeliverable from '../../atoms/item_descriptions/ItemDescriptionMailSlotDeliverable.vue'

export default {
  name: 'ItemDescriptionArea',
  components: {
    HeadingThree,
    HeadingFour,
    ItemDescriptionText,
    ItemDescriptionBoldText,
    ItemDescriptionImage,
    ItemDescriptionLink,
    ItemDescriptionMailSlotDeliverable
  },
  props: {
    descriptionItems: {
      type: Array,
      required: false,
      default: () => []
    },
    mailSlotDeliverable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    getMarginClass(index) {
      if (index === 0) {
        return ''
      }
      return 'item-description-margin-top'
    },
    getTextMarginClass(index) {
      if (index === 0) {
        return ''
      }
      const prevItem = this.descriptionItems[index - 1]
      const currentItem = this.descriptionItems[index]
      const isTextType = type => type === 'text' || type === 'bold'
      if (isTextType(prevItem.type) && isTextType(currentItem.type)) {
        return 'item-description-text-margin-top'
      }
      return 'item-description-margin-top'
    }
  }
}
</script>

<style lang="scss" scoped>
.item-description-area {
  display: flex;
  flex-direction: column;
}

.item-description-margin-top {
  margin-top: 24px;
}

.item-description-text-margin-top {
  margin-top: 5px;
}

.item-description-mail-slot-deliverable {
  margin-top: 24px;
}
</style>
